module.exports = __webpack_public_path__ + "static/HomepageImage-ef866c93692484b726b1142021bbcce6.png";